import { AxiosInstance } from "axios";
import { IdDto } from "../types/id/id-dto";
import { UserDto, UserPageDto } from "../types/user/user-dto";
import {
  CreateUserPayload,
  SearchUserPagePayload,
  UpdateUserPayload,
} from "../types/user/user-payload";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

export enum UserApiUrl {
  Create = "/v2/user",
  CreateBulk = "/v2/users",
  Update = "/v2/user",
  Delete = "/user",
  GetById = "/v2/user",
  Search = "/v2/users",
  GetMe = "/v2/user/me",
}

class UserApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async create(payload: CreateUserPayload): Promise<OngBaseResponse<IdDto>> {
    return await this._api.post(UserApiUrl.Create, payload);
  }

  async createBulk(payload: CreateUserPayload[]): Promise<OngBaseResponse<IdDto[]>> {
    return await this._api.post(UserApiUrl.CreateBulk, payload);
  }

  async update(
    id: string,
    payload: UpdateUserPayload
  ): Promise<OngBaseResponse<null>> {
    return await this._api.patch(`${UserApiUrl.Update}/${id}`, payload);
  }

  async delete(id: string): Promise<OngBaseResponse<null>> {
    return await this._api.delete(`${UserApiUrl.Delete}/${id}`);
  }

  async getById(id: string): Promise<OngBaseResponse<UserDto>> {
    return await this._api.get(`${UserApiUrl.GetById}/${id}`);
  }

  async search(
    payload: SearchUserPagePayload
  ): Promise<OngBaseResponse<UserPageDto>> {
    return await this._api.get(UserApiUrl.Search, {
      params: payload,
    });
  }

  async getMe(): Promise<OngBaseResponse<UserDto>> {
    return await this._api.get(UserApiUrl.GetMe);
  }
}

export const userApi = new UserApi(ongBaseApi);
